import api from './api';
import { Concepto } from '../types';

// Service for managing concepts/services catalog
class ConceptsService {
  async getConceptos(page = 1, limit = 100, search?: string) {
    const params = new URLSearchParams();
    params.append('page', page.toString());
    params.append('limit', limit.toString());
    if (search) params.append('search', search);

    const response = await api.get(`/conceptos?${params.toString()}`);
    return response.data;
  }

  async getConceptosActivos(): Promise<Concepto[]> {
    const response = await api.get('/conceptos/activos');
    return response.data;
  }

  async getConceptoById(id: number): Promise<Concepto> {
    const response = await api.get(`/conceptos/${id}`);
    return response.data;
  }

  async createConcepto(data: {
    nombre: string;
    descripcion?: string;
    codigo?: string;
    precioLista: number;
    rubroPresupuestalId?: number;
    activo?: boolean;
  }): Promise<Concepto> {
    const response = await api.post('/conceptos', data);
    return response.data;
  }

  async updateConcepto(id: number, data: {
    nombre?: string;
    descripcion?: string;
    codigo?: string;
    precioLista?: number;
    rubroPresupuestalId?: number;
    activo?: boolean;
  }): Promise<Concepto> {
    const response = await api.patch(`/conceptos/${id}`, data);
    return response.data;
  }

  async deleteConcepto(id: number): Promise<void> {
    await api.delete(`/conceptos/${id}`);
  }

  async toggleActivo(id: number): Promise<Concepto> {
    const response = await api.patch(`/conceptos/${id}/toggle`);
    return response.data;
  }
}

const conceptsService = new ConceptsService();
export default conceptsService;
